import React, { useState } from 'react';
import SidebarTemplate from 'components/templates/SidebarTemplate';
import FormContents from 'components/atoms/Form/FormContents';
import OrganizationInputForm from 'components/organismos/organization/OrganizationInputForm';
import OrganizationDomain from 'domain/organization';
import { Row, Col } from 'react-grid-system';
import FormPadding from 'components/atoms/Form/FormPadding';
import TabControl from 'components/atoms/TabControl';
import { css } from '@emotion/core';
import FormHeader from 'components/templates/FormHeader';
import BlockUI from 'components/molecules/BlockUi';

type SelectType = 'basic'|'manager'|'specialSalary';
const SelectType: {[key in SelectType]: SelectType} = {
  basic: 'basic',
  manager: 'manager',
  specialSalary: 'specialSalary',
};

const OrganizationAddPage: React.FC = () => {
  const [historyList, setHistoryList] = useState<Array<OrganizationDomain>>([]);
  const [organizationDomain, setOrganizationDomain] = useState<OrganizationDomain>(
    OrganizationDomain.generateInitial(),
  );
  const [selectType, setSelectType] = React.useState<SelectType>(SelectType.basic);
  return (
    <SidebarTemplate >
      {/* <FormContents>
        <FormTitle
          title="登録項目"
          note="* 全て必須"
        />

        <OrganizationInputForm
          initialOrganizationDomain={organizationDomain || undefined}
          setInitialOrganizationDomain={setOrganizationDomain}
          historyList={historyList}
          setHistoryList={setHistoryList}
        />
      </FormContents> */}
      <div className="block-ui-custom-container">
      <FormHeader title="組織作成"/>
        <FormContents customStyle={css({marginTop:'60px'})}>
          <FormPadding>            
            <Row>
              <Col md={3} xs={12}>
                <TabControl
                  items={[
                    {
                      value: SelectType.basic,
                      display: '基本情報',
                    },
                    // {
                    //   value: SelectType.manager,
                    //   display: 'マネージャー管理情報',
                    // },
                    // {
                    //   value: SelectType.specialSalary,
                    //   display: '特賃日割当情報',
                    // },
                  ]}
                  setValue={setSelectType as (arg: string) => void}
                  currentValue={selectType}
                  isFixed={false}
                  customStyle={css({paddingLeft:'0'})}
                />
              </Col>
            </Row>
          </FormPadding>
          {selectType === SelectType.basic
              && (
                <>
                  {/* <OrganizationInfoTable
                    organizationDomain={organizationDomain}
                  /> */}

                  <OrganizationInputForm
                    initialOrganizationDomain={organizationDomain || undefined}
                    setInitialOrganizationDomain={setOrganizationDomain}
                    historyList={historyList}
                    setHistoryList={setHistoryList}
                  />
                </>
              )}
          {/* {selectType === SelectType.manager
              && (
              <OrganizationManagerEditForm
                managerList={managerList}
                seniorManagerList={seniorManagerList}
                setManagerList={setManagerList}
                setSeniorManagerList={setSeniorManagerList}
                isEditMode={true}
              />
              )} */}
          {/* {selectType === SelectType.specialSalary
              && (
              <OrganizationSpecialSalaryEditForm
                isEditMode={true}
              />
              )} */}
        </FormContents>
 
      </div>
      
    </SidebarTemplate>
  );
};

export default OrganizationAddPage;
